import { useQuery } from 'react-query';
import request from '../helpers/request';

const getCompanies = async () => {
  const res = await request.get('/Request/companies', {}, '', []);
  return res;
};

const useCompanies = (options) => useQuery('companies', getCompanies, options);

export default useCompanies;
